<template>
    <div class="pagination">
        <el-pagination layout="prev, pager, next" @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="pageNum" :page-size="pagesize" :total="total">
        </el-pagination>
    </div>
</template>

<script>
export default {
    name: '',
    props: {
        pageNum: Number,
        pagesize: Number,
        total: Number
    },
    data() {
        return {
        };
    },
    computed: {
    },
    watch: {
    },
    methods: {
        handleSizeChange(val) {
            this.$emit('handleSizeChange', val)
        },
        handleCurrentChange(val) {
            this.$emit('handleCurrentChange', val)
        },
    },
};
</script>

<style scoped lang="less">
.pagination {
    .el-pagination {
        text-align: center;
        margin-top: 44px;

        /deep/.btn-prev {
            .el-icon-arrow-left::before {
                content: "\e6ea" !important;
            }
        }

        /deep/.btn-next {
            .el-icon-arrow-right::before {
                content: "\e6e9" !important;
            }
        }

        /deep/.el-pager li.active {
            color: @mainGrayColor2;
        }

        /deep/.el-pager li:hover {
            color: @mainGrayColor2;
        }
    }
}
</style>
